import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListTeknisiStaf, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import AccountResetEmail from "../../pagesSub/accountUser/AccountResetEmail";
import AccountResetUsernamePassword from "../../pagesSub/accountUser/AccountResetUsernamePassword";

const AccountTS = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListTeknisiStaf.account.slug;
    const roleUser = role.teknisi;
    const slugLink = roleUser.subLevel.teknisi_staf.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListTeknisiStaf}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListTeknisiStaf.account.subMenu.one.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListTeknisiStaf.account.subMenu.one.tabs.one.flag}>
                                {menuListTeknisiStaf.account.subMenu.one.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListTeknisiStaf.account.subMenu.one.tabs.two.flag}>
                                {menuListTeknisiStaf.account.subMenu.one.tabs.two.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListTeknisiStaf.account.subMenu.one.tabs.one.flag}>
                            <AccountResetEmail />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListTeknisiStaf.account.subMenu.one.tabs.two.flag}>
                            <AccountResetUsernamePassword />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default AccountTS;